import deepmerge from "deepmerge";
import { mapParamSetToString } from "./urlParams.utils";
/**
 * construct GET endpoint factories with given url base and ability to accept URL params
 * */
export function makeApiEndpointConfig(baseUrl, defaultParams, options) {
    if (baseUrl === void 0) { baseUrl = '/'; }
    return function (params) {
        var paramString = mapParamSetToString((params || {}), defaultParams, options);
        return [baseUrl, paramString].filter(function (i) { return i; }).join('?');
    };
}
/**
 *  alias for normal getMany endpoints with support for params,
 *  automatically appends filter[id]=1 so it retrieves one single resource
 */
export var makeApiGetEndpointConfig = function (baseUrl, defaultParams, options) {
    if (baseUrl === void 0) { baseUrl = '/'; }
    return function (id, params) {
        if (params === void 0) { params = {}; }
        return makeApiEndpointConfig(baseUrl, defaultParams, options)(deepmerge(params, { filter: { id: id } }));
    };
};
